import { PopupBanner } from '~containers/PopupResolver/PopupBanner/PopupBanner';
import { PopupCard } from '~containers/PopupResolver/PopupCard/PopupCard';
import { PopupPicture } from '~containers/PopupResolver/PopupPicture/PopupPicture';
import { PopupResolverProps } from '~containers/PopupResolver/PopupResolver.types';

export function PopupResolver(props: PopupResolverProps) {
  if (props.type === 'card') {
    return <PopupCard {...props} />;
  }
  if (props.type === 'banner') {
    return <PopupBanner {...props} />;
  }

  if (props.type === 'picture') {
    return <PopupPicture {...props} />;
  }

  return null;
}
